import { PrivacySettings } from '../privacy/CookieConsent';

interface FooterProps {
  onPrivacyClick: () => void;
  onContactClick: () => void;
}

export function Footer({ onPrivacyClick, onContactClick }: FooterProps) {
  return (
    <footer className="mt-16 bg-charcoal dark:bg-slate-950 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4">
          {/* Logo */}
          <img 
            src="/logo-icon.png" 
            alt="reverseTax" 
            className="h-8 w-8 opacity-80"
          />
          
          {/* Copyright & Links */}
          <div className="text-center">
            <p className="text-gray-300 dark:text-slate-300">
              © {new Date().getFullYear()} reverseTax. For educational purposes only.
            </p>
            <p className="text-gray-500 dark:text-slate-500 text-sm mt-1">
              Always consult a qualified tax professional for official advice.
            </p>
            <div className="mt-2 text-gray-400 dark:text-slate-400 text-xs flex items-center justify-center gap-3">
              <button 
                onClick={onPrivacyClick}
                className="hover:text-gray-300 dark:hover:text-slate-300 underline"
              >
                Privacy Policy
              </button>
              <span className="text-gray-600 dark:text-slate-600">|</span>
              <button 
                onClick={onContactClick}
                className="hover:text-gray-300 dark:hover:text-slate-300 underline"
              >
                Contact Us
              </button>
              <PrivacySettings />
            </div>
            <p className="text-gray-500 dark:text-slate-500 text-xs mt-3">
              Built by{' '}
              <a
                href="https://vdlsystems.co.za"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 dark:hover:text-slate-300 underline"
              >
                VDL Systems
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
